import { $t } from '@/i18n';
import { defineComponent } from '@vue/composition-api';
import modalFactory from '@/utils/modalFactory';
import styles from './styles.module.scss';
const modal = defineComponent({
    name: 'DebugInfoModal',
    props: {
        options: {
            type: Object,
            required: true,
        },
    },
    methods: {
        handleOk() {
            this.$emit('message', {
                success: true,
            });
        },
        handleCancel() {
            this.$emit('message', {
                success: false,
            });
        },
    },
    render() {
        return <a-modal visible={true} onOk={this.handleOk} onCancel={this.handleCancel} ok-text={$t('k_d9e6b92c')} cancel-text={$t('k_10c72f14')}>
      <div class={styles.container}>
        <p class={styles.title}>{$t('k_dc158dd2')}<span>{this.options.componentId}</span>{$t('k_31e6e541')}</p>
        <p class={styles.tip}>{$t('k_81386661')}</p>
        <p class={styles.warning}>{$t('k_9d098c4c')}</p>
      </div>
    </a-modal>;
    },
});
const openComponentInfoModal = modalFactory(modal);
export default openComponentInfoModal;
